module.exports = __webpack_public_path__ + "static/img/shapan2.fc69fc7f.png";